import { Auth } from '@aws-amplify/auth';
import CognitoApi from './CognitoApi';

let client = null;

export const loadClient = config => {
  if (!client) {
    Auth.configure({
      region: config.COGNITO_AWS_REGION,
      userPoolId: config.COGNITO_POOL_ID,
      userPoolWebClientId: config.COGNITO_CLIENT_ID,
    });

    client = new CognitoApi(config.COGNITO_AWS_REGION);
  }

  return client;
};

export const getClient = () => client;

export default Auth;
